import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { GoogleSignInButton } from "@/components/auth/GoogleSignInButton";
import ProductScreenshots from "@/components/landing/ProductScreenshots";

interface HeroSectionWebProps {
  handleAuthSuccess: () => void;
  handleAuthError: (error: string) => void;
}

export const HeroSectionWeb = ({ handleAuthSuccess, handleAuthError }: HeroSectionWebProps) => {
  return (
    <section className="pb-8 md:pb-12 pt-8 md:pt-12 bg-gradient-to-br from-background via-cream/30 to-sunset/10">
      <div className="container px-4 md:px-6 mx-auto">
        <div className="max-w-7xl mx-auto">
          <div className="text-center space-y-4">
            <div className="space-y-3">
              <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-charcoal font-playfair leading-tight">
                Your Family <span className="text-sunset">Meal Planner</span>
              </h1>
              
              <p className="text-base md:text-lg text-muted-foreground font-inter leading-relaxed max-w-4xl mx-auto">
                Bring everyone to the table. Save recipes from anywhere, plan a week of meals, shop from one smart list. All in one place, with a little AI magic.
              </p>
            </div>
            
            <div className="flex flex-col items-center gap-4">
              {/* Social Sign-in Options */}
              <div className="flex flex-col items-center gap-4 w-full max-w-sm">
                <div className="flex flex-col gap-3 w-full">
                  <GoogleSignInButton
                    variant="signup"
                    onSuccess={handleAuthSuccess}
                    onError={handleAuthError}
                  />
                </div>
                <div className="flex items-center gap-4 w-full">
                  <div className="flex-1 h-px bg-border"></div>
                  <span className="text-sm text-muted-foreground font-inter">or</span>
                  <div className="flex-1 h-px bg-border"></div>
                </div>
              </div>
              
              <div className="flex flex-col items-center gap-3">
                <Link to="/auth/register" className="w-full max-w-sm">
                  <Button className="w-full h-10 bg-sunset hover:bg-sunset-dark text-white font-inter font-medium">
                    Sign up with email
                    <ChevronRight className="ml-2 h-5 w-5" />
                  </Button>
                </Link>
                <p className="text-sm text-muted-foreground font-inter">
                  Start planning today • Free • No credit card needed • We respect your inbox
                </p>
              </div>
            </div>
            
            {/* Desktop Screenshots - shown below action buttons on large screens */}
            <div className="hidden lg:block">
              <ProductScreenshots />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};